import { render } from "./MFITTBookingBottomButton.vue?vue&type=template&id=08cdf97c"
import script from "./MFITTBookingBottomButton.vue?vue&type=script&lang=js"
export * from "./MFITTBookingBottomButton.vue?vue&type=script&lang=js"

import "./MFITTBookingBottomButton.vue?vue&type=style&index=0&id=08cdf97c&lang=css"
script.render = render

export default script